<template>
<div class="tableWithPerPageSelection">
  <div class="level mgt-20px">
    <div class="column is-narrow">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="recherche()" class="mgr-3">
          <!-- SearchBar -->
          <b-input :placeholder="$t('general.button.search')"
            type="search"
            icon="magnify"
            v-model="critereDevis.auto"
            >
            </b-input>
          </form>
          <!-- Filtre -->
          <button class="button" @click='changeValueShowFiltreAndLockMenu()'>
          <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
          </button>
          <span @click="reinitialiser()"
            class="info-circle-right is-pulled-right is-cursor-pointer">
            <b-icon icon="close-circle" type="is-danger"></b-icon>
          </span>
        </div>
      </div>
    </div>
    <div class="columns level-right">
      <div class="column is-narrow">
        <exportExcelButton
          :perm="constantes.DEVIS.exporter"
          :query="exportExcelQuery"/>
      </div>
      <parametrage-table
        :reference-table="constantes.refTableListLigneDevis"
        @endLoadParamtre="endLoadParametre = true">
      </parametrage-table>
    </div>
  </div>
    <!-- Array -->
    <v-server-table url=""
      :columns="columns"
      :options="options"
      @loading="debutLoading"
      class="overflow-x-auto"
      v-if="mountedLoadingEnd && endLoadParametre"
      @loaded="finLoading"
      :ref="constantes.refTableListLigneDevis"
    >
      <template slot='appendBody'>
        <table-footer-totaux
          :columns="columns"
          :target="targetTotal"
          :items="itemsDevis"
        >
        </table-footer-totaux>
      </template>
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[constantes.refTableListLigneDevis].setLimit($event)"
        >
        </table-items-in-view>
      </template>
      <!-- Formatage des dates -->
      <template slot="dateDevisCommande" slot-scope="props">
        <div class="is-pulled-right">
          {{ func.formatDate(props.row.dateDevisCommande) }}
        </div>
      </template>
      <template slot="datePremierAffichage" slot-scope="props">
        <div class="is-pulled-right">
          {{ func.formatDate(props.row.datePremierAffichage) }}
        </div>
      </template>
      <template slot="dateDebut" slot-scope="props">
        <div  class="is-pulled-right">
          {{ func.formatDate(props.row.dateDebut) }}
        </div>
      </template>
      <template slot="dateFin" slot-scope="props">
      <div class="is-pulled-right">
        {{ func.formatDate(props.row.dateFin) }}
      </div>
      </template>
      <template slot="totalHtAvecLigneRemise" slot-scope="props">
        <div class="is-pulled-right">
          {{ func.formatDevise(props.row.totalHtAvecLigneRemise) }}
      </div>
      </template>
      <template slot="montantHtDcf" slot-scope="props">
        <div class="is-pulled-right">
          {{ func.formatDevise(props.row.montantHtDcf) }}
        </div>
      </template>
      <template slot="listeIntervenants" slot-scope="props">
        <router-link-blank
          v-for="(client, index) in props.row.clientsNomCommerciauxIds"
          :key="index"
          v-bind="getRouteClient(client)">
        </router-link-blank>
      </template>
      <template slot="codeDcf" slot-scope="props">
        <router-link-blank
          :message="props.row.codeDcf"
          :to="{ name: 'c.bodac.devis',
          params : { id: props.row.devisCommandeId }}"
        >
        </router-link-blank>
      </template>
      <template slot="edit" slot-scope="props">
        <router-link-blank :to="{ name: 'm.bodac.devis',
          params: { id: props.row.devisCommandeId }}"
          icon="pencil-box-outline" typeIcon="is-success">
        </router-link-blank>
      </template>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight"
                :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-lignes-devis
        ref="filtreLignesDevis"
        @recherche="makeRechercheFilter()"
        @toggleFiltre="changeValueShowFiltreAndLockMenu()"
        />
      </div>
    </transition>
</div>
</template>
<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  SORT_ICON,
  RESULTS_PER_PAGE,
  TEXTS,
} from '@/configuration/clientTableConf';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { EXPORT_EXCEL_LIGNE_DEVIS, TYPE_DEVIS } from '@/configuration/devisConf';
import { SET_CRITERE } from '@/store/mutation-type';
import { DEVIS } from '@/configuration/permissionsBodacConf';
import formatDate from '@/services/general/formatDate';
import messageErreur from '@/services/general/messageErreur';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import { formatDevise } from '@/services/general/filters/formatDevise';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import { REFERENCE_TABLE_LIGNES_DEVIS } from '@/configuration/general/referenceTableConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import TableItemsInView from '@/components/general/TableItemsInView';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import parametrageTable from '@/components/general/parametrageTable';
import subscribeMutation from '@/services/store/subscribeMutation';
import checkPeriodeAndFormat from '@/services/dcf/checkPeriodeAndFormat';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { COMMERCIAL } from '@/configuration/parametrage/secteurConf';
import getSecteursIdByUser, { getSecteursByIds } from '@/services/commun/secteur/getSecteurs';
import filtreLignesDevis from './filtre/filtreLignesDevis';

const LignesDevis = createNamespacedHelpers('devisParLignesDevis');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  name: 'tabListeLignesDevis',
  data() {
    return {
      showFiltre: false,
      constantes: {
        refTableListLigneDevis: REFERENCE_TABLE_LIGNES_DEVIS,
        DEVIS,
        EXPORT_EXCEL_LIGNE_DEVIS,
      },
      endLoadParametre: false,
      mountedLoadingEnd: false,
      func: {
        formatDate,
        formatDevise,
      },
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  components: {
    exportExcelButton,
    routerLinkBlank,
    tableFooterTotaux,
    parametrageTable,
    TableItemsInView,
    filtreLignesDevis,
  },
  computed: {
    ...LignesDevis.mapGetters({
      itemsDevis: 'items',
      totalCountDevis: 'totalCount',
      lastPayloadDevis: 'lastPayload',
      critereDevis: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    nombreCritere() {
      const banCritere = ['autoRecherche', 'datesPremierAffichage', 'sens', 'typesDevisCommandeFacture'];
      let nbCritere = calculNombreCritere(this.critereDevis, banCritere);
      if (this.critereDevis.datesPremierAffichage) {
        nbCritere += this.critereDevis.datesPremierAffichage.dateDebut ? 1 : 0;
        nbCritere += this.critereDevis.datesPremierAffichage.dateFin ? 1 : 0;
      }
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    targetTotal() {
      return ['totalHtAvecLigneRemise'];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          planMediaCode: this.$i18n.t('listeLignesDevis.tabs.planMedia'),
          codeDcf: this.$i18n.t('listeLignesDevis.tabs.codeDevis'),
          codeDossier: this.$i18n.t('listeLignesDevis.tabs.codeDossier'),
          dateDevisCommande: this.$i18n.t('listeLignesDevis.tabs.dateDeDevis'),
          nomCommercial: this.$i18n.t('listeLignesDevis.tabs.commercial'),
          listeIntervenants: this.$i18n.t('listeLignesDevis.tabs.clients'),
          etatDcf: this.$i18n.t('listeLignesDevis.tabs.etat'),
          montantHtDcf: this.$i18n.t('listeLignesDevis.tabs.montantHt'),
          datePremierAffichage: this.$i18n.t('listeLignesDevis.tabs.dateCampagne'),
          totalHtAvecLigneRemise: this.$i18n.t('listeLignesDevis.tabs.totalHt'),
          dateDebut: this.$i18n.t('listeLignesDevis.tabs.dateDebut'),
          dateFin: this.$i18n.t('listeLignesDevis.tabs.dateFin'),
          libelle: this.$i18n.t('listeLignesDevis.tabs.produit'),
          lignesCommandeRegroupementLibelle: this.$i18n.t('listeLignesDevis.tabs.patrimoine'),
          typeProduit: this.$i18n.t('listeLignesDevis.tabs.typeProduit'),
          edit: '',
        },
        filterable: false,
        sortable: ['dateDevisCommande', 'libelle', 'montantHtDcf', 'etatDcf', 'planMediaCode', 'codeDcf', 'codeDossier', 'datePremierAffichage'],
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          if (!data.query) data.query = cloneDeep(this.critereDevis);
          this.gestionDataLoadLignesDevis(data);
          return this.loadLignesDevis(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.itemsDevis,
            count: this.totalCountDevis,
          };
        }),
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: this.constantes.EXPORT_EXCEL_LIGNE_DEVIS,
        typeExport: null,
        filtres: this.lastPayloadDevis,
      };
    },
    columns() {
      const cols = ['codeDcf', 'lignesCommandeRegroupementLibelle', 'libelle', 'dateDevisCommande', 'nomCommercial', 'listeIntervenants', 'etatDcf', 'datePremierAffichage', 'dateDebut', 'dateFin', 'codeDossier', 'totalHtAvecLigneRemise', 'montantHtDcf', 'typeProduit', 'edit'];
      return cols;
    },
  },
  methods: {
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...LignesDevis.mapActions({
      loadLignesDevis: 'loadLignesDevis',
    }),
    ...LignesDevis.mapMutations({
      setCritereRecherche: SET_CRITERE,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    async changeValueShowFiltreAndLockMenu() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) {
        await this.$refs.filtreLignesDevis.initializeFiltre();
      }
      this.setLockMenu(!this.lockMenu);
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.changeValueShowFiltreAndLockMenu();
      this.recherche();
    },
    gestionDataLoadLignesDevis(data) {
      checkPeriodeAndFormat(data.query, 'datesPremierAffichage');
      checkPeriodeAndFormat(data.query, 'dateDevisCommande');
      data.query.typesProduits = tagInputToArray(this.critereDevis.typesProduits, 'code');
      data.query.typesProduitRegroupement = tagInputToArray(this.critereDevis.typesProduitRegroupement, 'code');
      if (this.critereDevis.agencesId.length === 0) {
        data.query.agencesId = this.agencesSelectionnees.map(agence => agence.agenceId);
      }
      data.query.tiersId = this.critereDevis.tiersId.map(tiers => tiers.id);
      data.query.groupeIds = this.critereDevis.groupeIds.map(groupe => groupe.id);
      data.query.fournisseursId = this.critereDevis.fournisseursId.map(f => f.id);
      data.query.enseigneIds = this.critereDevis.enseigneIds.map(enseignes => enseignes.id);
      data.query.produitsIds = this.critereDevis.produitsIds.map(produit => produit.id);
      data.query.produitRegroupementIds = this.critereDevis.produitRegroupementIds.map(
        patrimoine => patrimoine.id,
      );
      data.query.societeId = this.societeActiveId;

      return data;
    },
    recherche() {
      this.$refs[this.constantes.refTableListLigneDevis].refresh();
      if (this.showFiltre) {
        this.showFiltre = !this.showFiltre;
      }
    },
    goFirstPageAndCheckChangement() {
      if (this.criteresRecherche.agencesId.length === 0) return;
      const agencesId = [];
      this.criteresRecherche.agencesId.forEach((id) => {
        const findInAgencesSelectionnes = this.agencesSelectionnees.some((agenceSelectionne) => {
          return agenceSelectionne.agenceId === id;
        });
        if (findInAgencesSelectionnes) agencesId.push(id);
      });
      this.criteresRecherche.agencesId = agencesId;
      this.$refs[this.referenceTable].setPage(1);
    },
    async reinitialiser() {
      await this.$refs.filtreLignesDevis.viderCritere();
      this.$refs.filtreLignesDevis.appliquerCritere();
      this.showFiltre = false;
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    getRouteClient(nomId) {
      return {
        to: {
          name: 'c.bodac.clients/contacts-client',
          params: {
            id: nomId.split('#')[1],
          },
        },
        message: nomId.split('#')[0],
      };
    },
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
    this.unsubscribeValue();
  },
  async mounted() {
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche);
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.moduleSecteur.key]);
      const critere = cloneDeep(this.critereDevis);
      this.critereDevis.typesDevisCommandeFacture = [TYPE_DEVIS];
      await updateCritereWithParametreInterne(critere);
      if (this.moduleSecteurActive) {
        const secteurCurrentUser = await getSecteursIdByUser(COMMERCIAL);
        if (secteurCurrentUser.length === 0
          && this.critereDevis.secteurIds.length > 0) {
          const secteurs = await getSecteursByIds(this.critereDevis.secteurIds, COMMERCIAL);
          critere.secteurIds = secteurs.map(secteur => secteur.id);
        } else {
          critere.secteurIds = secteurCurrentUser.map(secteur => secteur.id) ?? [];
        }
      }
      this.setCritereRecherche(critere);
      this.mountedLoadingEnd = true;
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
